import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { headerData } from '../../data/headerData';
import Cosmetictype from '../../components/Cosmetictype/Cosmetictype';

const ChatWidget = React.lazy(() => import('../../components/ChatWidget/ChatWidget'));

function Main() {
    return (
        <>
            <Helmet>
                <title>{headerData.name}</title>
                <meta name="description" content="دکتر سیمین — اولین مرجع علمی، پژوهشی و صنعتی محصولات آرایشی و بهداشتی در ایران. عطر و ادکلن، دوره‌های آموزشی زیبایی، مواد اولیه و بسته‌بندی." />
                <meta name="keywords" content="دکتر سیمین، آرایشی بهداشتی، عطر ادکلن، مواد اولیه آرایشی، دوره آموزش زیبایی، لاغری، پوست و مو" />
                <meta property="og:title" content={headerData.name} />
                <meta property="og:description" content="دکتر سیمین — مرجع آرایشی، بهداشتی و زیبایی ایران" />
                <meta property="og:url" content="https://drsimin.com" />
            </Helmet>
            <main>
                <Cosmetictype />
            </main>
            <Suspense fallback={null}>
                <ChatWidget />
            </Suspense>
        </>
    );
}

export default Main;
